<template>
  <section v-if="contextData" class="py-12">
    <div class="container-wrap">
      <p v-if="contextData.sectionName" class="text-sm font-bold text-gray-600">
        {{ contextData.sectionName }}
      </p>
      <h2 class="text-h2 mb-6 tablet:line-clamp-2">
        {{ contextData.title }}
      </h2>

      <ul
        v-if="contextTabs.length > 1"
        class="scrollbar-h-px extend-width mb-6 flex w-full overflow-y-hidden overflow-x-scroll desktop:flex-wrap desktop:overflow-x-hidden"
      >
        <li
          v-for="(item, index) in contextTabs"
          :key="hash(item)"
          class="mr-2 desktop:mb-2"
        >
          <button
            class="w-full rounded-3xl border border-solid border-gray-400 px-4 py-1.5 hover:bg-blue-400 hover:text-white"
            :class="
              current === index
                ? 'bg-blue-400 text-white'
                : 'bg-white text-blue-400'
            "
            :title="item"
            @click="current = index"
          >
            <span class="truncate text-left text-sm font-bold">
              {{ item }}
            </span>
          </button>
        </li>
      </ul>
      <SuiteSuccessfulCaseCard
        v-for="(item, index) in contextData.tabs"
        v-show="index === current"
        :key="hash(item)"
        :item-data="item"
        :url-connector="urlConnector"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface ISuccessfulCaseTab {
    tabName: string;
    name: string;
    // NOTE: 原本的 solution 是不允許寫入 HTML 的，但因為 Topics 元件共用的關係，這邊有將 description 調整為允許 HTML 的格式
    description: string;
    customerLogo: string;
    customerName: string;
    region: string;
    link: string;
    thumbnail: string;
    recommended?: string;
    authorName?: string;
    authorJobTitle?: string;
    authorIcon?: string;
    trackingCode?: string;
  }

  interface ISuccessfulCaseData {
    // NOTE: 原本沒有 sectionName，但因為 Topics 元件共用的關係有新增這個欄位
    sectionName?: string;
    title: string;
    tabs: ISuccessfulCaseTab[];
  }

  interface ISuccessfulCase {
    component: 'successful-case';
    meta: {
      navigable?: string;
    };
    data: ISuccessfulCaseData;
  }

  type IProps = ISuiteProps<ISuccessfulCase>;

  const props = defineProps<IProps>();

  const current = ref<number>(0);

  const contextData = computed((): ISuccessfulCaseData => props.suiteData.data);

  const contextTabs = computed((): string[] => {
    return contextData.value.tabs.map(
      (item: ISuccessfulCaseTab) => item.tabName
    );
  });

  export type { ISuccessfulCase, ISuccessfulCaseData, ISuccessfulCaseTab };
</script>
